import Service from "../Service";
const resource = "TasRawMaterialAnalysis/";

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    qualityAlertsPagination(parameters, requestID) {
        return Service.post(resource + "qualityAlertsPagination", parameters, {
            params: { requestID: requestID },
        });
    },
    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },
    updateApproval(obj, requestID) {
        return Service.post(resource + "updateApproval", obj, {
            params: { requestID: requestID },
        });
    },
    saveDirectorApproval(obj, requestID) {
        return Service.post(resource + "saveDirectorApproval", obj, {
            params: { requestID: requestID },
        });
    },
    AttachmentList(rmnID, requestID) {
        return Service.post(resource + "AttachmentList", {}, {
            params: {
                RmnID: rmnID,
                requestID: requestID,
            },
        });
    },
    UpdateAttachmentStatus(obj, requestID) {
        return Service.post(resource + "UpdateAttachmentStatus", obj, {
            params: {
                requestID: requestID,
            },
        });
    },
    AttachmentApprovalList(cmaID, fltID, requestID) {
        return Service.post(resource + "AttachmentApprovalList", {}, {
            params: {
                CmaID: cmaID,
                FltID: fltID,
                requestID: requestID,
            },
        });
    },
    heavyMetalsAnalysisReport(filter, requestID) {
        return Service.post(resource + "heavyMetalsAnalysisReport", filter, {
            params: {
                requestID: requestID,
            },
        });
    },
    pesticidesAnalysisReport(filter, requestID) {
        return Service.post(resource + "pesticidesAnalysisReport", filter, {
            params: {
                requestID: requestID,
            },
        });
    },
    rawMaterialApprovalReport(filter, requestID) {
        return Service.post(resource + "rawMaterialApprovalReport", filter, {
            params: {
                requestID: requestID,
            },
        });
    },
    requestSave(obj, requestID) {
        return Service.post(resource + "requestSave", obj, {
            params: { requestID: requestID },
        });
    },
    requestPagination(parameters, requestID, isAttended = -1) {
        return Service.post(resource + "requestPagination", parameters, {
            params: { requestID: requestID, isAttended: isAttended },
        });
    },
    requestAttend(rmrID, rmnIDGenerated, requestID) {
        return Service.post(resource + "requestAttend", {}, {
            params: {
                RmrID: rmrID,
                RmnID_Generated: rmnIDGenerated,
                requestID: requestID,
            },
        });
    },
}